import { z } from "zod";

export const brandingSchema = z.enum([
  "needl",
  "pwc",
  "msquared",
  "icra",
  "icra-researchassist",
  "armada",
  "softwareone",
]);

export type BrandingType = z.infer<typeof brandingSchema>;

export const BRANDING = {
  NEEDL: "needl",
  PWC: "pwc",
  MSQUARED: "msquared",
  ICRA: "icra",
  ICRA_RESEARCH_ASSIST: "icra-researchassist",
  ARMADA: "armada",
  SOFTWARE_ONE: "softwareone",
} as const satisfies Record<string, BrandingType>;

export interface BrandingConfig {
  logo: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  /** Variant of logo for use against the sidebar's dark background (collapsed state). Falls back to logo when not set. */
  logoOnDark?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  logoFull?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  /** Variant of logoFull for use against the sidebar's dark background, e.g. an all-white version of the wordmark. Falls back to logoFull when not set. */
  logoFullOnDark?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  logoFullClassName?: string;
  favicon: string;
  name: string;
  scAppName: string;
  disclaimerAppName: string;
  showName: boolean;
  botAvatar?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  /** URL of a self-contained animated SVG shown as the session-load logo.
      When unset, the consumer falls back to its generic spinner. */
  chatLoadingLogo?: string;
  loginWelcomeText?: string | React.ReactNode;
  loginFooterContent?: React.ReactNode;
  loginSubHeadingText?: string;
  scLandingSubheading?: string;
  scLandingPlaceholders?: string[];
  scLandingHeadlines?: string[];
  /** Marketing panel on the Auto-DD auth screens. The panel is omitted when unset. */
  autoDdPitch?: {
    product: { name: string; tagline: string };
    headline: React.ReactNode;
    body: string;
    points: string[];
    trustPoints: string[];
  };
}

export interface BrandingOptions {
  title: string;
  faviconHref: string;
}
